import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild, AfterViewInit, AfterContentChecked, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DhlFormControlEventData } from '../../dhl-form/models/dhl-form-control-event-data';
import { AppService } from 'src/app/app.service';
import { TranslateService } from '@ngx-translate/core';
import { Constant } from '../../constants/constants';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';

@Component({
    selector: 'app-generic-filter-v2',
    templateUrl: './generic-filter-v2.component.html',
    styleUrls: ['./generic-filter-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericFilterV2Component implements OnInit, AfterViewInit, AfterContentChecked {

  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;

  focusedOption: number = -1;
  placeHolderText = "";
  selectAllText = "All";
  comma = ",";
  selectedValues = "";
  dropIsClosed = true;
  selectedOpt: any;
  sortAsc = true;
  checkboxAllStatus = false;
  showDropSelect = false;
  disabled: boolean = false;
  hidden: boolean = false;
  clickedInsideComponent: boolean = false;
  isInitialLoad:boolean = true;
  slectedOptApi:any=[];
  commonData = Constant;
  //CP-2522: parameters for Storage session issue for default filter
  defFilterFlag = false;
  defFilter;
  depValue;
  depFlag;

  @ViewChild('dropdown', {static: true, read: ElementRef}) dropdown: ElementRef;
  @ViewChild('dropdownselect', {static: true, read: ElementRef}) dropdownselect: ElementRef;  
  @ViewChild('dropIcon', {static: true, read: ElementRef}) dropIcon: ElementRef;
  @ViewChild('options', {static: true, read: ElementRef}) options: ElementRef;
  @ViewChild('dropdownouter', {static: true, read: ElementRef}) dropdownouter: ElementRef;
  @ViewChild('sortIcon', {static: true, read: ElementRef}) sortIcon: ElementRef;  

  get getSelectAllTxt() {
    return this.selectAllText;
  }

  constructor(private renderer: Renderer2,private appService: AppService, private _eref: ElementRef,public translate: TranslateService, private alphaService : AlphaService) {
  }

  @HostListener('document:click', ['$event']) 
  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target)){
      this.dropIsClosed = true;
      this.dropdown.nativeElement.classList.remove('filled');
      this.dropdown.nativeElement.classList.remove('focus');
    }
  }

  // isClickInsideComponent(element, classname) {
  //   if (element && element.className && element.className.split(' ').indexOf(classname) >= 0 && element.id == this.configData.name) return true;
  //   return element.parentNode && this.isClickInsideComponent(element.parentNode, classname);
  // }

  ngOnInit() {
    this.disabled = this.configData.disabled;
    this.hidden = this.configData.hidden;

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj?.[this.configData.name]) {
      this.selectedValues = filterObj[this.configData.name];
    } else {
      this.selectedValues = this.configData.placeHolder || this.configData.placeholder;
    }
    if (this.configData.disabled) {
      this.frmGroup.get(this.configData.name)['required'] = false;
      this.configData.required = false;
    }

    // this.renderer.listen('window', 'click', (e: Event) => {
    //   this.clickedInsideComponent = this.isClickInsideComponent(e.target, 'dhl-dropdown');
    //   if (!this.clickedInsideComponent || ((this.dropselect && e.target !== this.dropselect.nativeElement) && (this.droplabel && e.target !== this.droplabel.nativeElement) &&
    //     e.target !== this.dropdown.nativeElement && e.target !== this.dropdownselect.nativeElement &&
    //     e.target !== this.options.nativeElement && (this.dropIcon && e.target !== this.dropIcon.nativeElement) &&
    //     e.target !== this.dropdownouter.nativeElement && (this.sortIcon && e.target !== this.sortIcon.nativeElement))) {
    //     this.focusout();
    //   }
    // });
    this.placeHolderText = this.configData.placeHolder || this.configData.placeholder;
  }

  toggleEnable(bool) {
    this.disabled = bool;
  }

  toggleHidden(bool) {
    this.hidden = bool;
  }

  ngAfterViewInit() {
    /* Start :CP-2522 - code for making option some value as default instead of 'All' as default */
       this.configData.options.forEach(option => {
      if(option.defaultFilter){
        //this.selectedOption(option,false)
        this.defFilterFlag = true;
        this.defFilter = option;
        this.depValue = option['displayValue']
      }
    });
        /* End :CP-2522 - code for making option some value as default instead of 'All' as default */
    //this.checkboxAllStatus= true;
    this.selectAllText = this.translate.instant(this.commonData.Filter_Popup_Status_All);

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj?.[this.configData.name] && Array.isArray(filterObj[this.configData.name]) && filterObj[this.configData.name].length > 0) {
      this.configData.options.forEach(option => option['selected'] = false);
      this.selectedOption(filterObj[this.configData.name], true, false);
      this.frmGroup.get(this.configData.name).statusChanges.subscribe(x => {
        if (this.frmGroup.get(this.configData.name).value == undefined) {
          this.dropdown.nativeElement.classList.remove('filled');
        } else {
          this.frmGroup.get(this.configData.name).markAsDirty();
        }
      });
      return;
    }
    if(sessionStorage.getItem(this.configData.storeDataName) && this.configData.hasOwnProperty("storeDataName")) {
      let localStatus = JSON.parse(sessionStorage.getItem(this.configData.storeDataName))
      let status = localStatus;
    //  this.frmGroup.get(this.configData.name).setValue(status);

       if(!Array.isArray (status)){
         var statusArr = status.split(',');
         this.selectedOption(statusArr, true);
       }else if(sessionStorage.getItem("all"+this.configData.storeDataName) === "true"){
        this.selectedOption('All', true);
       }else{
          /* Start :CP-2522 - code for making option some value as default instead of 'All' as default */
         let dependentArr :any=[];
         for(let option of this.configData.options){
           if(option['add'] == this.depValue){
              dependentArr.push(option['value'])
           }
         };
         if(dependentArr.length != status.length){
            this.depFlag = false;
          }
          else
           for (let stat of status){
                if(!dependentArr.includes(stat)){
                  this.depFlag = false;
                  break;
                }
                else{
                  this.depFlag = true;
                }
           }

         if(this.depFlag){
           this.selectedOption(this.defFilter,false)
         }/* End :CP-2522 - code for making option some value as default instead of 'All' as default */
         else{
           this.selectedOption(status, true);
         }
       }
    }
    else if(Array.isArray(this.selectedValues)){
      this.selectedOption(this.selectedValues, true);
    }
    else if(this.defFilterFlag){//CP-2522: for making default filter instead of 'All' when open the page
      this.selectedOption(this.defFilter,false)
    }
    else {
     // this.selectedOption('All', true);
      this.selectedOption(this.translate.instant(this.commonData.Filter_Popup_Status_All), true)
    }
    if (Object.keys(this.configData.defaultValue).length > 0) {
      this.selectedOption( this.configData.defaultValue, true);
    }else if(this.frmGroup.get(this.configData.name).value.length > 0){
      //this.selectedOption(this.frmGroup.get(this.configData.name).value, true);
       }
    this.frmGroup.get(this.configData.name).statusChanges.subscribe(x => {
      if (this.frmGroup.get(this.configData.name).value == undefined) {
        this.dropdown.nativeElement.classList.remove('filled');
      } else {
        this.frmGroup.get(this.configData.name).markAsDirty();
      }
    });
    // if(this.dropselect){
    //   this.dropselect.nativeElement.style.width = this.dropdownselect.nativeElement.offsetWidth + "px";
    // }
  }

  ngAfterContentChecked() {
    if (!this.dropIsClosed) {
      this.positionDrop();
    }
  }

  toggleDrop(target) {
    if (target.classList.value.indexOf('sort-icon') == -1 ||
        (target.classList.value.indexOf('sort-icon') > -1 && this.dropIsClosed)) {
      this.dropIsClosed = !this.dropIsClosed;
      if (this.sortIcon && this.dropIsClosed) {
        this.dropdown.nativeElement.classList.remove('focus');
        if(this.dropIcon){
          this.dropIcon.nativeElement.classList.replace('open', 'closed');
        }
        if (this.configData.sortable) {
          this.sortIcon.nativeElement.classList.replace('default', 'filled');
        }
      } else {
        this.dropdown.nativeElement.classList.add('focus');
        if(this.dropIcon){
          this.dropIcon.nativeElement.classList.replace('closed', 'open');
        }
        this.dropdown.nativeElement.focus();
      }
    }
  }

  sortOptions() {
    if (this.configData.options.length > 0) {
      if (this.sortAsc) {
        this.configData.options.sort((a, b) => a.displayValue < b.displayValue ? -1 : a.displayValue > b.displayValue ? 1 : 0);
      } else {
        this.configData.options.sort((a, b) => a.displayValue > b.displayValue ? -1 : a.displayValue < b.displayValue ? 1 : 0);
      }
    }
    this.sortAsc = !this.sortAsc;
  }

  positionDrop() {
    const { left, top } = this.options.nativeElement.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let elOffsetTop = top + scrollTop;
    let elHeight = this.options.nativeElement.offsetHeight;
    let heightOfDropdown = this.dropdownouter.nativeElement.offsetHeight;
    let mainContentAreaPaddingBottom = 24; //document.getElementsByClassName('main-content-area').style.paddingBottom;
    if ((window.innerHeight - mainContentAreaPaddingBottom) < elOffsetTop + elHeight) {
      this.options.nativeElement.classList.add('ulta');
      this.options.nativeElement.style.top = (7 - elHeight) + "px";
      this.options.nativeElement.style.width = this.dropdownouter.nativeElement.offsetWidth + "px";
    } else {
      this.options.nativeElement.classList.remove('ulta');
      this.options.nativeElement.style.top = (heightOfDropdown - 7) + "px";
      this.options.nativeElement.style.width = this.dropdownouter.nativeElement.offsetWidth + "px";
    }
  }

  focusout(forced?:boolean) {
    this.dropIsClosed = true;
    this.dropdown.nativeElement.classList.remove('focus');
    if(this.dropIcon){
      this.dropIcon.nativeElement.classList.replace('open', 'closed');
    }
    this.dropdown.nativeElement.classList.remove('tab-focus');
    if(forced){
      this.frmGroup.get(this.configData.name).markAsTouched();
    }
  }

  focusin() {
    if (this.dropdown && this.options && this.options.nativeElement.classList.value.indexOf('hide') > -1) {
      this.dropdown.nativeElement.classList.add('tab-focus');
    }
  }

  selectedOption(selOpt, selectDefault, sendToParent = true) {
    if(selOpt != undefined && selOpt != null)
      if (selOpt['dependent']){
      let dependent = selOpt["displayValue"];
      selOpt["selected"] = !selOpt["selected"]; //true;
      let arr: any[] = [];
      let count = 0;
      this.selectedValues = "";

      if (selOpt['selected']){
        this.selectedValues = dependent;
        this.configData.options.forEach((option) => {
          if (option["add"] != undefined && option["add"] != null && option["add"] == dependent) {
            option["selected"] = true;
            arr.push(option.value);
            count++;
            //this.selectedValues +=option["displayValue"] + this.comma + " ";
          }
          else if(!option["dependent"]){
            option['selected'] = false;
          }
        });
        console.log("array", arr);
        //this.selectedValues = this.selectedValues.replace(/,\s*$/, "").trim();
        this.frmGroup.get(this.configData.name).setValue(arr);
        this.dropdown.nativeElement.classList.add("filled");
        // this.droplabel.nativeElement.classList.remove('large');
        this.showDropSelect = true;

      }
      else if (!selOpt['selected']){
        this.configData.options.forEach((option) => {
          if (option["add"] != undefined && option["add"] != null && option["add"] == dependent) {
            option["selected"] = false;
          }
        });
        this.selectedValues = "--Select--"
       this.frmGroup.get(this.configData.name).setValue(arr);
       this.dropdown.nativeElement.classList.add("filled");
       // this.droplabel.nativeElement.classList.remove('large');
       this.showDropSelect = true;


      }
    }
   else
    if(selectDefault && Array.isArray(selOpt)){
      this.selectedValues = "";
      let arr = [];
      if(selOpt.length == 1 && selOpt[0] == this.selectAllText){
        this.selectedOption(this.selectAllText, false);
      }else{
        let count=0;
        selOpt.forEach(value => {
		  this.configData.options.forEach(option => {
			if(option.value == value){
			  option["selected"] = true;
        		  // this.selectedValues += option["displayValue"] + this.comma + " ";
			  let optiondata = option["displayValue"];
		          let datamerge = this.translate.instant(optiondata);
		          this.selectedValues += datamerge + this.comma + " ";
			  arr.push(option.value);
			  count++;
			}
		  });
		  this.checkboxAllStatus = count == this.configData.options.length ? true : false;
          this.selectedValues = this.checkboxAllStatus? this.selectAllText : this.selectedValues;
        });
      }
      this.selectedValues = this.selectedValues.replace(/,\s*$/, "").trim();
      this.frmGroup.get(this.configData.name).setValue(arr);
      //this.droplabel.nativeElement.classList.remove('large');
      this.dropdown.nativeElement.classList.add('filled');
      this.showDropSelect = true;
    }else{
      if(typeof selOpt == 'string' && selOpt.toUpperCase() == this.selectAllText.toUpperCase()){
        this.selectedValues = "";
        this.checkboxAllStatus = !this.checkboxAllStatus;
        this.showDropSelect = this.checkboxAllStatus;
        if (this.checkboxAllStatus) {
          let arr = [];
		  this.configData.options.forEach(option => {
			option["selected"] = this.checkboxAllStatus;
			if(option["selected"] && option.value != undefined && option.value != null){
			 // this.selectedValues += option["displayValue"] + this.comma + " ";
			  arr.push(option.value);
			}
		  });
          //this.selectedValues = this.selectAllText;
          this.selectedValues = this.commonData.Filter_Popup_Status_All;
          this.selectedValues = this.selectedValues.replace(/,\s*$/, "").trim();
          let translateData = this.translate.instant(this.selectedValues);
          this.selectedValues = translateData;
          this.frmGroup.get(this.configData.name).setValue(arr);
         // this.droplabel.nativeElement.classList.remove('large');
          this.dropdown.nativeElement.classList.add('filled');
        } else {

          let arr = [];
          this.configData.options.forEach(option => {
            option["selected"] = this.checkboxAllStatus;
          });
            //this.selectedValues = this.configData.placeholder;
          this.frmGroup.get(this.configData.name).setValue(arr);
         // this.droplabel.nativeElement.classList.add('large');
          this.dropdown.nativeElement.classList.remove('filled');
        }
      } else {

        // selection option is already selected
        if(typeof selOpt == 'object' && selOpt !== this.selectAllText.toUpperCase() && this.selectedValues.indexOf(selOpt["displayValue"]) > -1){
          // removing the selected item
          selOpt['selected'] = !selOpt['selected'];
          // toggling check box for select all, if checked
          this.checkboxAllStatus = false;
          let arr = [];
          this.selectedValues = "";
          this.configData.options.forEach(option => {
            if(option["selected"] && option.value != undefined && option.value != null){
              let optiondata = option["displayValue"];
              let datamerge = this.translate.instant(optiondata);
              this.selectedValues += datamerge + this.comma + " ";
              //this.selectedValues += option["displayValue"] + this.comma + " ";
              arr.push(option.value);
            }
          });
          this.selectedValues = this.selectedValues.replace(/,\s*$/, "").trim();
          this.frmGroup.get(this.configData.name).setValue(arr);
          if (this.selectedValues.length == 0) {
            this.dropdown.nativeElement.classList.remove('filled');
            this.showDropSelect = false;
           // this.droplabel.nativeElement.classList.add('large');
            // this.selectedValues = this.configData.placeholder;
          }
        } else {
          // select the item and check if all items are selected
          let dependent = "";
          selOpt['selected'] = !selOpt['selected']; //true;
          let arr = [];
          this.selectedValues = "";
          let count = 0;
          this.configData.options.forEach(option => {
            if(option["selected"] && option.value !=undefined && option.value != null){
              let optiondata = option["displayValue"];
              let datamerge = this.translate.instant(optiondata);
              this.selectedValues += datamerge + this.comma + " ";
              //this.selectedValues += option["displayValue"] + this.comma + " ";
              arr.push(option.value);
              count++;
            }
            if(option["dependent"]){
              dependent = option["displayValue"]
              if(!selOpt['selected'] && selOpt['add'] == dependent){
                option['selected'] = false;
              }
              else if (selOpt["selected"] && selOpt["add"] != dependent) {
                option['selected'] = false;
              }
            }
          });
          console.log('Check arr  ', arr)
		  if(localStorage.getItem("status"))
		  {
			this.checkboxAllStatus = count == this.slectedOptApi.length ? true : false;
		  }
		  else
		  {
			this.checkboxAllStatus = count == this.configData.options.length ? true : false;
		  }
          this.selectedValues = this.checkboxAllStatus? this.selectAllText : this.selectedValues;
          this.selectedValues = this.selectedValues.replace(/,\s*$/, "").trim();
          this.frmGroup.get(this.configData.name).setValue(arr);
          this.dropdown.nativeElement.classList.add('filled');
         // this.droplabel.nativeElement.classList.remove('large');
          this.showDropSelect = true;
        }
      }
      // if (this.configData.sortable) {
      //   if (selOpt !== undefined) {
      //     this.sortIcon.nativeElement.classList.replace('focused', 'default');
      //   } else {
      //     this.sortIcon.nativeElement.classList.replace('focused', 'filled');
      //   }
      // }
    }

    // method call to filter order on the basis of status
    // sendToParent=false only when calling from generic-form-filter-v2.component.ts clear method
    if((this.isInitialLoad && this.checkboxAllStatus) || sendToParent == false) {
      this.isInitialLoad = false;
    } else{

      // check if the page loads for the first time and ALL is selected, then don't call API to filter orders
    this.isInitialLoad = false;
    this.sendSelectedValuesToSource();
    }
  }
  sendSelectedValuesToSource() {
     let sourceData = this.frmGroup.get(this.configData.name).value;
	 console.log("sourceData:::",sourceData);
     let queryString = this.generateQueryString(sourceData);
    if(this.configData.allEmpty && this.checkboxAllStatus)
     {
       queryString = "";
     }
        let events = this.configData.events;
        if(events && events.length > 0) {
        let eventData: DhlFormControlEventData = {
          event: events[0].event,
          eventData: events[0],
          action: events[0].action,
          name: this.configData.name,
          component: this,
          configData: this.configData,
          data: {value: sourceData, queryString: queryString }
        }
        if(this.configData.hasOwnProperty("storeDataName")){
          sessionStorage.setItem(this.configData.storeDataName, JSON.stringify(sourceData));
        }
        sessionStorage.setItem("all"+this.configData.storeDataName, this.checkboxAllStatus.toString())

        let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
        if (filterObj) {
          filterObj[this.configData.name] = this.frmGroup.get(this.configData.name).value;
          this.alphaService.setFilteredObject("setFiltersValues", filterObj);
        }
        this.appService._commonComponentSubject.next(eventData);
      }
    }

  generateQueryString(sourceData){
    let queryString = '';
    if (Array.isArray(sourceData)) {
      //START: To handle multiple values in selected filter, Sprint-28-CP-2858
      var chart : any = [];
      sourceData.forEach(ele => {
        let chart2 = ele.split(',');
        chart.push(chart2); //[[],[],[]]
      });
      // To Extract Nested Array
      let result = chart.reduce((c, v) => c.concat(v), []).map(o => o);
      sourceData = result;
      // END: Sprint-28-CP-2858
      sourceData.forEach(ele => {
        queryString += '&' + this.configData.name + '=' + ele;
      });
    }
    return queryString;
  }

  // @HostListener("window:keydown", ['$event'])
  // onKeyDown(event: KeyboardEvent) {
  //   if (this.dropdown.nativeElement.classList.value.indexOf('tab-focus') > -1
  //     || this.dropdown.nativeElement.classList.value.indexOf('focus') > -1) {
  //     const optionsOuter = this.options.nativeElement;
  //     const options = optionsOuter.children[0].children;
  //     if (event.key == 'ArrowDown' && this.options.nativeElement.classList.value.indexOf('hide') > -1) {
  //       this.toggleDrop(event.target);
  //     } else if (event.key == 'ArrowDown') {
  //       if (this.focusedOption > -1 && options.length > 0 && this.focusedOption < options.length) {
  //         options[this.focusedOption].classList.remove('hover')
  //       }
  //       this.focusedOption += 1;
  //       if (this.focusedOption >= options.length) {
  //         this.focusedOption = options.length - 1;
  //       }
  //       if (this.focusedOption < options.length) {
  //         options[this.focusedOption].classList.add('hover');
  //         options[this.focusedOption].scrollIntoView({ behavior: "smooth", inline: "nearest" });
  //       }
  //     }
  //     if (event.key == 'ArrowUp' && this.options.nativeElement.classList.value.indexOf('hide') == -1) {
  //       if (this.focusedOption > 0) {
  //         options[this.focusedOption].classList.remove('hover')
  //       }
  //       this.focusedOption -= 1;
  //       if (this.focusedOption <= 0) {
  //         this.focusedOption = 0;
  //       }
  //       if (this.focusedOption < options.length && this.focusedOption > -1) {
  //         options[this.focusedOption].classList.add('hover');
  //         options[this.focusedOption].scrollIntoView({ behavior: "smooth", inline: "nearest" });
  //       }
  //     }
  //     if (event.key == 'Enter' && this.options.nativeElement.classList.value.indexOf('hide') == -1) {
  //       this.focusedOption == 0 ? this.selectedOption( this.selectAllText, false) : this.selectedOption( this.configData.options[this.focusedOption - 1], false);
  //     }
  //     if (event.key == 'Tab') {
  //       this.focusout(true);
  //     }
  //   }
  // }
}
